import React, { useEffect, useState } from 'react';
import { getHFModels, HFResult } from '../../utils/api';
import { formatCompact, formatInt } from '../../utils/format';
import { DataBadge } from '../DataBadge';
import { SourceRef } from '../SourceRef';
import { PageSources } from '../PageSources';
export function HFLiveTable() {
  const [result, setResult] = useState<HFResult | null>(null);
  useEffect(() => {
    let alive = true;
    getHFModels().then(r => alive && setResult(r));
    return () => {
      alive = false;
    };
  }, []);
  const max = result ? Math.max(...result.models.map(m => m.downloads), 1) : 1;
  return <div data-id="element-559" data-mp="1ieo1f79v21vc">
      <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-560" data-mp="1idw67xk6e65l">
        <h2 className="font-serif text-2xl text-ink md:text-3xl" data-id="element-561" data-mp="1neshiw6uwul1">
          Most-downloaded on Hugging Face
          <SourceRef id="hfApi" data-id="element-562" data-mp="2ttkvwwotdja3" />
        </h2>
      </div>
      <PageSources data-id="element-563" data-mp="2ytp9oeyc7zwm">
        <DataBadge mode={result ? result.mode : 'loading'} source="Hugging Face · most downloaded" asOf={result?.asOf} data-id="element-564" data-mp="2yt60pnqo0luq" />
      </PageSources>
      <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-565" data-mp="3h92wvp3fp1ne">
        What actually runs: downloads are dominated by small embedding and encoder models, not frontier chat models.
      </p>
      <ol className="mt-6 divide-y divide-line border-y border-line" data-id="element-566" data-mp="37adg5zn9xn8q">
        {(result?.models ?? []).map((m, i) => <li key={m.id} className="grid grid-cols-[2.5rem_minmax(0,1fr)_auto] items-center gap-x-4 py-2.5 md:grid-cols-[2.5rem_minmax(0,22rem)_minmax(0,1fr)_7rem_5rem]" data-id="element-567" data-mp="32eo9zdgr183g" data-mpi={i}>
            <span className="font-mono text-[12px] text-muted" data-id="element-568" data-mp="2tji0o4i9s7w6">{i + 1}</span>
            <a href={`https://huggingface.co/${m.id}`} target="_blank" rel="noopener noreferrer" className="truncate text-[13.5px] text-ink hover:text-machine" data-id="element-569" data-mp="2okdsnh730g7f">
              {m.id}
            </a>
            <div className="hidden h-1.5 rounded-full bg-raised md:block" aria-hidden="true" data-id="element-570" data-mp="2en93d8hxw4me">
              <div className="h-full rounded-full bg-machine/70" style={{
            width: `${m.downloads / max * 100}%`
          }} data-id="element-571" data-mp="2akw0qsyhomtu" />
            </div>
            <span className="text-right font-mono text-[12.5px] tabular text-ink" title={`${formatInt(m.downloads)} downloads`} data-id="element-572" data-mp="1zyqxztkwfb92">
              {formatCompact(m.downloads)}
            </span>
            <span className="hidden text-right font-mono text-[11.5px] text-muted md:block" data-id="element-573" data-mp="1r0xdrh0es829">♥ {formatCompact(m.likes)}</span>
          </li>)}
        {!result && <li className="py-10 text-center font-mono text-xs text-muted" role="status" data-id="element-574" data-mp="2jnro3l3ihr20">
            Fetching live layer…
          </li>}
      </ol>
      <p className="mt-2 font-mono text-[11px] text-faint" data-id="element-575" data-mp="2nrzavcqeswxl">Downloads over the trailing 30 days as reported by the Hub API.</p>
    </div>;
}